function getStructuredData(breadCrumbs) {
  const domain = process.env.GATSBY_SITE_DOMAIN;
  const makeUrlFull = (url) => (url.indexOf('http') === 0 ? url : `${domain}${url.indexOf('/') === 0 ? '' : '/'}${url}`);
  const getBreadCrumbsItemList = () => {
    const result = breadCrumbs.map((bread, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: bread.label,
      ...(i + 1 !== breadCrumbs.length && { item: makeUrlFull(bread.href) }),
    }));

    return result;
  };

  // @look https://developers.google.com/search/docs/appearance/structured-data/breadcrumb#json-ld_1
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: getBreadCrumbsItemList(),
  };
}
export default getStructuredData;
